import * as actionType from "./actions";

// fetch exam analysis
export const fetchExamAnalysis = (body) => ({
  type: actionType.FETCH_EXAM_ANALYSIS,
  body,
});

export const fetchExamAnalysisSuccess = (analysisData) => ({
  type: actionType.FETCH_EXAM_ANALYSIS_SUCCESS,
  payload: analysisData,
});

export const fetchExamAnalysisError = (error) => ({
  type: actionType.FETCH_EXAM_ANALYSIS_ERROR,
  payload: error,
});

// clear exam analysis
export const clearExamAnalysis = () => ({
  type: actionType.CLEAR_EXAM_ANALYSIS,
});